import React, { useEffect, useRef, useState } from "react";
import ImageEditor from "../../AdminportalFolder/RecceApproval/ImageEditor.js";
import {
  Grid,
  Typography,
  Box,
  Container,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Divider,
  Dialog,
  DialogActions,
  IconButton,
  CircularProgress,
} from "@mui/material";
import { toPng } from "html-to-image";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import HighlightAltOutlinedIcon from "@mui/icons-material/HighlightAltOutlined";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import styles from "./ProductReport.module.css";
import axios from "axios";
import bike from "../../../shared/assets/icons/bike.jpg";
import tree from "../../../shared/assets/icons/tree.jpg";
import houses from "../../../shared/assets/icons/houses.jpg";
import jsPDF from "jspdf";
import CapitalizeFirstLetter from "../../../shared/utils/CapitalizeFirstLetter.jsx";
import GlobalButton from "../../../shared/utils/GlobalButton.jsx"; // Adjust path as needed

const reportData2 = {
  logoInfo: {
    logoUrl: "",
  },
  RecceReport: {
    IPName: "hitesh",
    TotalJobsDone: "240",
    Rating: "4.4",
  },
  productDetails: {
    productCategory: "Backlit Signage",
    productName: "Backlit Signage",
    budget: "₹1000",
    timeline: "2 Mar 2024 - 22 Jul 2024",
  },

  imageUrls: [houses, tree, bike, houses],

  imageUrlsx: [houses, tree],

  imageUrlss: [houses, tree, bike],

  captions: ["Weak Civil Structure", "Congestion", "Non Plastered"],
};

const ProductReport = ({
  open,
  setOpen,
  currentApproval,
  finalSpaces,
  timelineJobId,
  installationCheck,
  getApprovalList,
  handleStatus,
  actionButton,
}) => {
  const [loading, setLoading] = React.useState(true);
  const handleClose = () => setOpen(false);
  const [reportData, setReportData] = React.useState([]);
  const [clientApprovedDimensions, setClientApprovedDimensions] =
    React.useState(
      finalSpaces?.find((fs) => fs.id === currentApproval?.product?._id),
    );
  const [dataForTable, setDataForTable] = React.useState([]);
  const reportRef = useRef(); // Reference for PDF conversion
  const [isImageEditorOpen, setIsImageEditorOpen] = useState(false);
  const clientId = localStorage.getItem("clientId");

  const {
    logoInfo,
    productDetails,
    imageUrls,
    imageUrlss,
    imageUrlsx,
    captions,
    RecceReport,
  } = reportData2;
  const [approvalData, setApprovalData] = useState({});
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const preloadImages = async () => {
    const images = document.querySelectorAll("img");

    const promises = [...images].map((img) => {
      return new Promise((resolve, reject) => {
        if (img.complete) {
          resolve(); // Image already loaded
        } else {
          img.onload = resolve;
          img.onerror = () => reject(`Failed to load image: ${img.src}`);
        }
      });
    });

    try {
      await Promise.all(promises);
      setImagesLoaded(true); // ✅ Indicate images are loaded
    } catch (error) {
      console.error("❌ Image preload error:", error);
      setImagesLoaded(true); // Even if some images fail, allow the process to continue
    }
  };

  const getApprovalData = async () => {
    let check = false;
    if (installationCheck == true) {
      check = true;
    }

    const serverURL = process.env.REACT_APP_URL;
    try {
      const token = localStorage.getItem("token");
      const id = timelineJobId ? timelineJobId : currentApproval?.jobId;
      const response = await axios.get(
        `${serverURL}/installationPartnerJobApproval/viewJobApproval/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      if (response.data.success) {
        let responseOfApproval = response.data.data;
        setApprovalData(responseOfApproval); // Store API data

        preloadImages();
        let tableData2 = [
          {
            heading: "Dimensions",
            approvedByClient: `${
              responseOfApproval?.product?.approvedWidth || "-"
            } ft x ${responseOfApproval?.product?.approvedHeight || "-"} ft`,
            previous: `${
              responseOfApproval.product?.productWidth || "-"
            } ft x ${responseOfApproval.product?.productHeight || "-"} ft `,

            recceOutput: `${
              responseOfApproval?.job?.productDimensionsAfterRecce?.width || "-"
            } ft x ${
              responseOfApproval?.job?.productDimensionsAfterRecce?.height ||
              "-"
            } ft`,
          },
          {
            heading: "Area",
            approvedByClient: `${
              responseOfApproval?.product?.approvedWidth *
              responseOfApproval?.product?.approvedHeight
            } sq ft`,
            availableSpace:
              responseOfApproval.job?.productDimensionsAfterRecce?.width.toFixed(
                2,
              ) *
              responseOfApproval.job?.productDimensionsAfterRecce?.height.toFixed(
                2,
              ),
            previous: `${
              responseOfApproval.product?.productHeight.toFixed(2) *
              responseOfApproval.product?.productWidth.toFixed(2)
            } Sq. Ft.`,
            recceOutput: `${(
              Number(
                responseOfApproval.job?.productDimensionsAfterRecce?.width || 0,
              ) *
              Number(
                responseOfApproval.job?.productDimensionsAfterRecce?.height ||
                  0,
              )
            ).toFixed(2)} Sq. Ft.`,
          },
          {
            heading: "Type Of Wall",
            previous: "-",
            recceOutput: `${responseOfApproval?.job?.typeOfMountingBase || "-"}`,
            approvedByClient: "-",
          },
          // {
          //   heading: "Depth",
          //   previous: "-",
          //   recceOutput: `${
          //     responseOfApproval.job?.productDimensionsAfterRecce?.depth || "-"
          //   } in`,
          //   approvedByClient: "-",
          // },
          // {
          //   heading: "Mounting Height",
          //   previous: "-",
          //   recceOutput: `${responseOfApproval?.job?.mountingHeight || "-"}`,
          //   approvedByClient: "-",
          // },
          // {
          //   heading: "Measurement Tool",
          //   previous: "-",
          //   recceOutput: `${responseOfApproval?.job.modeOfMeasurement || "-"}`,
          //   approvedByClient: "-",
          // },
          // {
          //   heading: "Type Of Installation Surface",
          //   previous: "-",
          //   recceOutput: `${responseOfApproval?.job.typeOfMountingBase || "-"}`,
          //   approvedByClient: "-",
          // },
          // {
          //   heading: "Application",
          //   previous: "-",
          //   recceOutput: `${responseOfApproval?.job.installationPlace || "-"}`,
          //   approvedByClient: "-",
          // },
          // {
          //   heading: "Safety Risk",
          //   previous: `-`,
          //   recceOutput: `${responseOfApproval?.job.possibleSafetyRisk}`,
          //   approvedByClient: `-`,
          // },
          // {
          //   heading: "Power Point",
          //   previous: "-",
          //   recceOutput: `${
          //     responseOfApproval?.job.isPowerPointAvailability || "-"
          //   }`,
          //   approvedByClient: "-",
          // },
          {
            heading: "External Equipment Required",
            previous: "-",
            recceOutput: `${responseOfApproval?.job.externalEquipments}`,
            approvedByClient: "-",
          },
          // {
          //   heading: "Accessibility",
          //   previous: "-",
          //   recceOutput: `${
          //     responseOfApproval?.job.isLocationAccessible || "-"
          //   }`,
          //   approvedByClient: "-",
          // },
        ];
        setLoading(false);
        setReportData(response.data.data);
        setDataForTable(tableData2);
      }
    } catch (error) {
      setLoading(false);

      console.error("Error fetching campaign:", error);
    }
  };

  useEffect(() => {
    getApprovalData();
  }, []);

  useEffect(() => {
    if (approvalData && Object.keys(approvalData).length > 0) {
      preloadImages();
    }
  }, [approvalData]);
  const fetchImageAsBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl, { mode: "cors" });

      if (!response.ok) {
        throw new Error(`Failed to fetch image: ${response.statusText}`);
      }

      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result); // base64
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error(`❌ Error fetching image: ${imageUrl}`, error);
      return null;
    }
  };

  const replaceImageSrcWithBase64 = async () => {
    const imgElements = document.querySelectorAll("img");

    for (let img of imgElements) {
      const src = img.getAttribute("src");

      if (src && !src.startsWith("data:image")) {
        const base64 = await fetchImageAsBase64(src);

        if (base64) {
          img.src = base64; // Replace API image with Base64 version
        }
      }
    }
  };
  const waitAndRepaint = async () => {
    await preloadImages();
    await new Promise((res) => setTimeout(res, 300)); // allow full paint

    // Force a reflow
    void document.body.offsetHeight;
  };

  const forceBrowserRepaint = (element) => {
    // Force style recalculation
    element.style.display = "none";
    void element.offsetHeight; // trigger reflow
    element.style.display = "";
  };
  const waitForImagesToLoad = async (element) => {
    const images = element.querySelectorAll("img");
    const promises = [];

    images.forEach((img) => {
      if (!img.complete || img.naturalHeight === 0) {
        promises.push(
          new Promise((res, rej) => {
            img.onload = res;
            img.onerror = rej;
          }),
        );
      }
    });

    return Promise.all(promises);
  };
  const downloadPDF = async () => {
    if (!imagesLoaded) {
      console.error("❌ Images are still loading, please wait...");
      alert("Please wait for all images to load before downloading.");
      return;
    }

    try {
      setLoadingDownload(true);

      const element = reportRef.current;
      if (!element) return;

      await preloadImages(); // Ensure images are loaded
      await replaceImageSrcWithBase64(); // Fallback for CORS
      forceBrowserRepaint(element);
      await waitForImagesToLoad(element);
      await waitAndRepaint();

      // 👉 Convert to PNG using html-to-image
      const dataUrl = await toPng(element, {
        quality: 0.5, // Maximum quality (0-1)
        pixelRatio: 2, // Higher resolution rendering
        backgroundColor: "#FFFFFF",
        cacheBust: true,
        useCORS: true,
      });

      // 👉 Create PDF and add image
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "px",
        format: "a4",
        compress: true, // Disable compression for better quality
      });

      const marginX = 0;
      const marginY = 0;
      const pageWidth = pdf.internal.pageSize.getWidth() - 2 * marginX;

      const img = new Image();
      img.src = dataUrl;

      img.onload = () => {
        const imgHeight = (img.height * pageWidth) / img.width;

        pdf.addImage(dataUrl, "PNG", marginX, marginY, pageWidth, imgHeight);
        let campaignName = CapitalizeFirstLetter(
          reportData?.campaign?.campaignTitle,
        );
        pdf.save(
          `${reportData?.job?.storeName}_${reportData?.job?.city}_${campaignName}_RecceReport.pdf`,
        );
      };
    } catch (error) {
      console.error("❌ Error capturing PDF:", error);
    } finally {
      setLoadingDownload(false);
    }
  };

  React.useEffect(() => {
    if (currentApproval) {
      getApprovalData();
    }
  }, []);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          minHeight: "200px",
          width: "100%",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
  return (
    <>
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
          maxWidth="lg"
          fullWidth
          className="custom-dialog"
          PaperProps={{
            className: "custom-dialog-paper",
          }}
        >
          <div>
            <div className="w-[90%] flex justify-between items-center mt-3">
              <span className=" ml-8 text-xl">RECCE REPORT</span>

              <div>
                <div className=" flex gap-2">
                  {actionButton && (
                    <>
                      <GlobalButton
                        variant="primary"
                        size="small"
                        disabled={
                          currentApproval?.adminStatus === 1 ||
                          currentApproval?.adminStatus === -1 ||
                          currentApproval?.clientStatus === 1 ||
                          currentApproval?.clientStatus === -1 ||
                          currentApproval?.job?.rework === true
                        }
                        onClick={() =>
                          handleStatus(
                            currentApproval?._id,
                            currentApproval,
                            "approve",
                          )
                        }
                      >
                        {`APPROVE`}
                      </GlobalButton>

                      <GlobalButton
                        variant="secondary"
                        size="small"
                        disabled={
                          currentApproval?.adminStatus === 1 ||
                          currentApproval?.adminStatus === -1 ||
                          currentApproval?.clientStatus === 1 ||
                          currentApproval?.clientStatus === -1 ||
                          currentApproval?.job?.rework === true
                        }
                        onClick={() =>
                          handleStatus(
                            currentApproval?._id,
                            currentApproval,
                            "rework",
                          )
                        }
                      >
                        {`REWORK`}
                      </GlobalButton>

                      <GlobalButton
                        variant="secondary"
                        size="small"
                        disabled={
                          currentApproval?.adminStatus === 1 ||
                          currentApproval?.adminStatus === -1 ||
                          currentApproval?.clientStatus === 1 ||
                          currentApproval?.clientStatus === -1 ||
                          currentApproval?.job?.rework === true
                        }
                        onClick={() =>
                          handleStatus(
                            currentApproval?._id,
                            currentApproval,
                            "reject",
                          )
                        }
                      >
                        {`REJECT`}
                      </GlobalButton>
                    </>
                  )}
                  {!timelineJobId && !clientId && (
                    <GlobalButton
                      variant="primary"
                      size="small"
                      disabled={currentApproval?.clientStatus == 1}
                      onClick={() => setIsImageEditorOpen(true)}
                    >
                      {`Edit Image`}
                    </GlobalButton>
                  )}
                  <GlobalButton
                    variant="primary"
                    size="small"
                    isLoading={loadingDownload}
                    onClick={downloadPDF}
                  >
                    {`Download PDF`}
                  </GlobalButton>
                </div>
                <IconButton
                  className={styles.iconButton}
                  aria-label="close"
                  onClick={handleClose}
                >
                  <CloseIcon />
                </IconButton>
              </div>
            </div>
            <div ref={reportRef}>
              <Box
                className={`${styles.productTextBackGround} p-4  bg-gradient-to-r from-white to-blue-50 `}
              >
                {/* BLUE LINE */}
                <div className="flex justify-center items-center">
                  {/* <div className="h-[3px] bg-blue-500 mb-4 rounded-full w-[70%]" /> */}

                  <img
                    src="/assests/images/pixell dark.png"
                    className="h-14 ml-auto mb-2"
                  />
                </div>

                <Grid container alignItems="center" margin="20px 0">
                  <Grid item md={8}>
                    <div className="flex items-center">
                      {reportData?.organizationDetail?.brandLogo ? (
                        <img
                          src={reportData?.organizationDetail?.brandLogo}
                          className="h-24  mb-2"
                        />
                      ) : (
                        <div className="w-20 h-20 rounded-md border border-1" />
                      )}
                      <div className="mx-4">
                        <h1 className="text-3xl text-black">Recce Report</h1>

                        <p className="text-gray-500 text-sm mt-1">
                          Site measurement details
                        </p>
                      </div>
                    </div>
                  </Grid>

                  <Grid item md={4} className="text-right">
                    <Typography className="text-sm">
                      Campaign Id:{" "}
                      <span className="font-semibold">
                        {reportData?.campaign?.campaignSerialNumber}
                      </span>
                    </Typography>

                    <Typography className="text-sm">
                      Campaign Name:{" "}
                      <span className="font-semibold">
                        {reportData?.campaign?.campaignTitle}
                      </span>
                    </Typography>

                    <Typography className="text-sm">
                      Recce Date:{" "}
                      <span className="font-semibold">
                        {moment(
                          reportData?.job?.dateOnWhichJobCompleted,
                        ).format("DD MMM YYYY")}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>

                <div className="h-[2px] bg-gray-500 mb-4 rounded-full " />

                <div className="grid grid-cols-12 gap-4 my-8">
                  <div className="col-span-12 md:col-span-6">
                    <div className="bg-white rounded-xl p-4 shadow-sm h-full">
                      <h5 className="font-semibold my-2">Site Details</h5>

                      <p className="flex items-center gap-2 text-[14px] mt-1 font-bold">
                        {" "}
                        <StorefrontOutlinedIcon />
                        {reportData?.job?.storeName}
                      </p>

                      <div className="flex items-center">
                        <p className="flex items-center gap-2 text-[14px] mt-1">
                          <Person2OutlinedIcon />
                          {reportData?.job?.storeOwnerName}
                        </p>

                        <p className="flex  ml-24 items-center gap-2 text-[14px] mt-1">
                          <LocalPhoneOutlinedIcon />
                          {reportData?.job?.storeOwnerPhoneNumber}
                        </p>
                      </div>

                      <p className="flex items-start gap-2 text-[14px] mt-1">
                        <LocationOnOutlinedIcon /> {reportData?.job?.address},{" "}
                        {reportData?.job?.city}, {reportData?.job?.state}{" "}
                        {reportData?.job?.zipCode}
                      </p>
                    </div>
                  </div>

                  <div className="col-span-12 md:col-span-3">
                    <div className="bg-white rounded-xl p-4 shadow-sm h-full">
                      <h5 className="font-semibold my-2">Product Info</h5>

                      <div className="flex  items-start mt-4">
                        {reportData?.product?.printImage ? (
                          <img
                            src={reportData?.product?.printImage}
                            className="w-18 h-16 object-cover"
                          />
                        ) : (
                          <div className="w-16 h-16 rounded-md border border-1" />
                        )}

                        <div className="mx-4">
                          <p className="text-[14px] font-bold">
                            {reportData?.product?.productType}
                          </p>

                          <p className="text-[14px] text-gray-500">
                            <HighlightAltOutlinedIcon />{" "}
                            {reportData?.product?.productWidth}ft ×{" "}
                            {reportData?.product?.productHeight}ft
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-span-12 md:col-span-3">
                    <div className="bg-white rounded-xl p-4 shadow-sm h-full">
                      <h5 className="font-semibold my-2">Recce Partner</h5>

                      <div className="flex items-start mt-4">
                        {reportData?.installationPartner?.profilePhoto ? (
                          <img
                            src={reportData?.installationPartner?.profilePhoto}
                            className="w-18 h-16 rounded-md object-cover"
                          />
                        ) : (
                          <div className="w-18 h-16 rounded-md border border-1" />
                        )}

                        <div className="mx-4">
                          <p className="text-[14px] font-bold">
                            <Person2OutlinedIcon />{" "}
                            {reportData?.installationPartner?.name}
                          </p>

                          <p className="flex items-center gap-1 text-[14px] ml-1 mt-1">
                            ⭐{" "}
                            {reportData?.installationPartner?.rating || "4.8"}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="my-8 flex flex-col items-start rounded-md bg-white p-4">
                  <img
                    loading="eager"
                    src={reportData?.job?.imageOfRecceSpace || imageUrls[0]}
                    className="w-[-webkit-fill-available] object-contain rounded-md"
                    style={{ alignSelf: "flex-start" }}
                  />

                  <div className=" flex justify-between items-center w-full mt-2">
                    <p className="text-[14px] text-gray-400 mb-2 mt-1 ">
                      Measurement captured during site recce
                    </p>
                    {reportData?.job?.updatedBy && (
                      <p className="text-[14px] text-gray-400 mb-2 mt-1">
                        Updated By: {reportData.job.updatedBy.name || "N/A"} -{" "}
                        {reportData.job.updatedBy.email || "N/A"}
                      </p>
                    )}
                  </div>
                </div>

                <div className="my-8 bg-white rounded-xl p-4 shadow-sm">
                  <h5 className="font-semibold my-4">Recce Details</h5>

                  <div className="overflow-hidden">
                    <table className="w-full text-sm border-collapse">
                      <thead>
                        <tr className="bg-gray-100 rounded-lg">
                          <th className="text-left py-6 px-2 font-medium rounded-l-lg">
                            S. No.
                          </th>

                          <th className="text-left py-6 px-2 font-medium">
                            Heading
                          </th>

                          <th className="text-left py-6 px-2 font-medium">
                            Proposed Specifications
                          </th>

                          <th className="text-left py-6 px-2 font-medium">
                            Recce Output
                          </th>

                          <th className="text-left py-6 px-2 font-medium rounded-r-lg">
                            Approved by Client
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {dataForTable?.map((row, index) => (
                          <tr key={index} className="border-b last:border-b-0">
                            <td className="py-6 px-2">{index + 1}</td>

                            <td className="py-6 px-2">{row.heading || "-"}</td>

                            <td className="py-6 px-2">{row.previous || "-"}</td>

                            <td className="py-6 px-2">
                              {/* {row.recceOutput !== null &&
                              row.recceOutput !== "" &&
                              !isNaN(row.recceOutput)
                                ? Number(row.recceOutput).toFixed(2)
                                : "-"} */}
                              {row.recceOutput || "-"}
                            </td>

                            <td className="py-6 px-2">
                              {row.approvedByClient || "-"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {reportData?.job?.remarks && (
                  <div className="my-8 bg-[#f1ffdb] rounded-xl p-4 shadow-sm">
                    <h3 className="mb-2">Recce Remarks</h3>
                    <p>{reportData?.job?.remarks}</p>
                  </div>
                )}

                <div className="h-[2px] bg-gray-500 mb-4 rounded-full " />

                <div className="mt-4 mb-2 flex justify-between text-[16px] text-gray-400 ">
                  <span>Generated Via Pixell Recce Application</span>
                  <span>www.pixell.in</span>
                </div>
              </Box>
            </div>
          </div>
          <div>
            <ImageEditor
              open={isImageEditorOpen}
              setOpen={setIsImageEditorOpen}
              image={reportData?.job?.storeImagesDuringRecce?.frontPhoto}
              job={currentApproval?.job}
              getApprovalList={getApprovalList}
              width={Math.round(
                reportData?.job?.productDimensionsAfterRecce?.width * 12,
              )}
              height={Math.round(
                reportData?.job?.productDimensionsAfterRecce?.height * 12,
              )}
              getApprovalData={getApprovalData}
            />
          </div>
        </Dialog>
      </div>
    </>
  );
};

export default ProductReport;
